import React from "react";

export const IconCloakroom = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m9.4657 6.4869c0-1.3746 1.1356-2.4869 2.5388-2.4869 1.4033 0 2.5388 1.1123 2.5388 2.4869 0 1.3746-1.1355 2.4869-2.5388 2.4869v1.9533m0 0 9.8598 4.5849c0.674 0.3075 1.1448 0.9857 1.1356 1.7544 0 1.0671-0.8863 1.9352-1.9757 1.9352h-18.049c-1.0894 0-1.9756-0.8681-1.9756-1.9352 0-0.7777 0.47083-1.4469 1.1448-1.7544l9.8597-4.5849z"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconCloakroom;
